import {
  ApplicationInsights,
  DistributedTracingModes,
} from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import type { ICustomProperties } from '@microsoft/applicationinsights-web'

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING

export const reactPlugin = new ReactPlugin()

export const appInsights = connectionString
  ? new ApplicationInsights({
      config: {
        connectionString,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: false,
        enableResponseHeaderTracking: false,
        enableUnhandledPromiseRejectionTracking: true,
        distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
      },
    })
  : null

export function initializeTelemetry() {
  appInsights?.loadAppInsights()
  appInsights?.addTelemetryInitializer((envelope) => {
    envelope.tags = envelope.tags || {}
    envelope.tags['ai.cloud.role'] = 'frontend-web'
  })
}

export function trackException(error: Error, properties?: ICustomProperties) {
  appInsights?.trackException({ exception: error }, properties)
}

export function trackMetric(
  name: string,
  average: number,
  properties?: ICustomProperties,
) {
  appInsights?.trackMetric({ name, average }, properties)
}

export function trackEvent(name: string, properties?: ICustomProperties) {
  appInsights?.trackEvent({ name }, properties)
}
